(function () {
  function revealImg(img) {
    img.classList.add('img-revealed');
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var img = entry.target;
      observer.unobserve(img);
      if (img.complete && img.naturalWidth > 0) {
        revealImg(img);
      } else {
        img.addEventListener('load', function () { revealImg(img); }, { once: true });
        img.addEventListener('error', function () { revealImg(img); }, { once: true });
      }
    });
  }, { threshold: 0.05 });

  function watchImg(img) {
    observer.observe(img);
  }

  document.querySelectorAll('img[loading="lazy"]').forEach(watchImg);

  // Handle images injected dynamically (Section Rendering API, sliders, etc.)
  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        var imgs = node.matches('img[loading="lazy"]') ? [node] : node.querySelectorAll('img[loading="lazy"]');
        imgs.forEach(watchImg);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
